export default {
  // 通用
  common: {
    search: '搜索',
    submit: '提交',
    cancel: '取消',
    close: '关闭',
    loading: '加载中...',
    success: '成功',
    error: '错误',
    required: '必填',
    optional: '可选'
  },
  
  // 应用标题
  app: {
    title: '最终幻想14交易板价格查询'
  },
  
  // 搜索区域
  search: {
    inputPlaceholder: '输入道具名称',
    noResults: '未找到相关信息'
  },
  
  // 价格表格
  priceTable: {
    headers: {
      pricePerUnit: '单价',
      quantity: '数量',
      server: '服务器',
      retainer: '雇员',
      total: '总价'
    }
  },
  
  // 意见反馈
  feedback: {
    title: '意见反馈',
    description: '您的每一条建议都是我们改进的动力，帮助我们打造更好的体验',
    contentLabel: '您的意见或建议',
    contentPlaceholder: '请详细描述您的意见或建议，我们会认真阅读每一条反馈...',
    emailLabel: '联系邮箱',
    emailPlaceholder: '如需回复，请留下您的邮箱地址',
    emailTooltip: '我们承诺保护您的隐私，邮箱仅用于回复反馈',
    submitButton: '提交反馈',
    processingTime: '我们重视您的每一条反馈，通常会在1-3个工作日内处理',
    
    // 验证消息
    validation: {
      contentRequired: '请输入您的意见或建议',
      contentMinLength: '请至少输入10个字符',
      contentMaxLength: '意见内容不能超过500个字符',
      emailInvalid: '请输入有效的邮箱地址'
    },
    
    // 提示消息
    messages: {
      submitSuccess: '意见提交成功，感谢您的反馈！',
      submitError: '意见提交失败，请稍后重试'
    }
  },
  
  // 语言切换
  language: {
    switch: '切换语言',
    chinese: '中文',
    english: 'English'
  }
}